<template>
  <!-- 个人中心发布资讯页面 -->
  <div class="artic">
    <el-form ref="form" v-if="id==undefined" :model="form">
      <div class="borderLine">
        <el-form-item label="" class="titleInp" prop="title">
          <el-input placeholder="输入标题（8 - 30字）" v-model="title1" minlength="8"></el-input>
          <span>{{title1.length}}/30</span>
        </el-form-item>
        <el-form-item label="" class="contentInp">
          <!--富文本编辑器-->
          <div class="editor" style="height: 600px;z-index: 1000;position: static">
            <div ref="toolbar" class="toolbar">
            </div>
            <div ref="editor" class="text" style="height: 550px;z-index: 1000; position: static">
            </div>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="封面">
        <i class="el-icon-info"></i>
      </el-form-item>
      <el-form-item label="">
       <div class="upLoadFile">
          <el-form-item label="" prop="name" enctype="multipart/form-data">
            <el-upload ref='upload' action="https://researchadmin.qudong.com/api/upload/upload_img" :on-exceed="exMax"
              :on-success="success" name="image" :limit="maxNum" multiple="multiple"
              :on-preview="handlePictureCardPreview" list-type="picture-card" :on-remove="handleRemove"
              :headers="headers">
              <i  class="el-icon-plus" style="display:block"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form-item>

      <div>
        <el-checkbox v-model="checked" style="margin-right:20px;">关联研报</el-checkbox>
        <el-select v-model="valueOne" :disabled="checked==false" @change="selectChange1($event)" filterable multiple
          placeholder="输入关键词搜索研报">
          <el-option v-for="(item) in optionsOne" :key="item.id" :label="item.chinese_title" :value="item.id">
          </el-option>
        </el-select>
        <span style="color: #999999;margin-left:15px;">(可多选)</span>
      </div>

      <div>
        <el-checkbox v-model="checked1" style="margin-right:20px;margin-top:30px;">关联专利</el-checkbox>
        <el-select v-model="valueTwo" :disabled="checked1==false" @change="selectChange2($event)" filterable multiple
          placeholder="输入关键词搜索专利">
          <el-option v-for="(item) in optionsTwo" :key="item.id" :label="item.patent_name" :value="item.id">
          </el-option>
        </el-select>
        <span style="color: #999999;margin-left:15px;">(可多选)</span>
      </div>
      <el-form-item style="margin-top:40px;">
        <el-button type="primary" @click="onSubmit(0)">发布</el-button>
        <el-button @click="onSubmit(3)">存草稿</el-button>
      </el-form-item>
    </el-form>

    <!-- 修改 -->
    <el-form ref="form" v-if="id!=undefined" :model="form">
      <div class="borderLine">
        <el-form-item label="" class="titleInp" prop="title">
          <el-input placeholder="输入标题（8 - 30字）" v-model="title1" minlength="8"></el-input>
          <span>{{form.title.length}}/30</span>
        </el-form-item>
        <el-form-item label="" class="contentInp">
          <!--富文本编辑器-->
          <div class="editor" style="height: 600px;z-index: 1000;position: static">
            <div ref="toolbar" class="toolbar">
            </div>
            <div ref="editor" class="text" style="height: 550px;z-index: 1000; position: static">
            </div>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="封面">
        <i class="el-icon-info"></i>
      </el-form-item>

      <el-form-item label="">
        <div class="upLoadFile">
          <el-form-item label="" prop="name" enctype="multipart/form-data">
            <el-upload ref='upload' action="https://researchadmin.qudong.com/api/upload/upload_img" :on-exceed="exMax"
              :on-success="success1" name="image" :limit="maxNum" multiple="multiple"
              :on-preview="handlePictureCardPreview" list-type="picture-card" :on-remove="handleRemove"
              :headers="headers">
              <img ref="displaynone" style="width:148px;height:148px;" :src="dialogImageUrl" alt="">
              <i  ref="displaynonei" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form-item>

      <!-- 修改 -->
      <div>
        <el-checkbox v-model="checked" style="margin-right:20px;">关联研报</el-checkbox>
        <el-select v-model="valueOne" :disabled="checked==false" @change="selectChange1($event)" filterable multiple
          placeholder="输入关键词搜索专利">
          <el-option v-for="(item) in optionsOne" :key="item.id" :label="item.chinese_title" :value="item.id">
          </el-option>
        </el-select>
        <span style="color: #999999;margin-left:15px;">(可多选)</span>
      </div>

      <div>
        <el-checkbox v-model="checked1" style="margin-right:20px;margin-top:30px;">关联专利</el-checkbox>
        <el-select v-model="valueTwo" :disabled="checked1==false" @change="selectChange2($event)" filterable multiple
          placeholder="输入关键词搜索专利">
          <el-option v-for="(item) in optionsTwo" :key="item.id" :label="item.patent_name" :value="item.id">
          </el-option>
        </el-select>
        <span style="color: #999999;margin-left:15px;">(可多选)</span>
      </div>
      <el-form-item style="margin-top:40px;">
        <el-button type="primary" @click="onSubmit(0)">发布</el-button>
        <el-button @click="onSubmit(3)">存草稿</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import E from "wangeditor";
import Axios from "axios";
import { userReportSearch, userPatentSearch, userInfos } from "@/api/api";
// import { articleTypeAPI, sendArticleAPI } from "@/request/api";
// import { detail } from "@/request/api";
// import { meirishengyu } from "@/request/api";
// import UpLoadFile from "../UpLoadFile.vue";
// import { LeftTheDay } from "@/request/api"; // 剩余发文篇数
// import { userRights } from "@/request/api"; // 用户权益接口 - 判断用户双标题  加精等权益的显示
export default {
  metaInfo(){
     return{
        title: '资讯发布',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },  
  name: "ReleaseInformation",
  data() {
    return {
      checked: false,
      checked1: false,
      Arr: "",
      Arr1: "",
      optionsTwo: [],
      valueOne: [],
      optionsOne: [],
      valueTwo: [],
      msg: "",
      tinymceHtml: "",
      title1: "",
      headers: {
        token: JSON.parse(localStorage.getItem("userInfo")).token,
      },
      dialogImageUrl: "",
      dialogVisible: false,
      maxNum: 1,
      fileList: [],
      temp: [],
      form: {
        id: "",
        title: "",
        titleS: "",
        subhead_status: 0,
        cover: "",
        original: 0,
        self_recommend: 0, // 自荐
        fans_present: 0, // 粉丝必现
        citiao: false,
        lianzai: false,
        artOpt: [],
        category_id: "",
        user_define_publish_time: "", //用户自定义发布时间
      },
      already_num: 0, // 发文数
      surplus_num: 0, // 剩余发文数
      mustAppear: 0,
      value: "", //文章内容
      sub_title: 0, //双标题
      original: 0,
      recommend_oneself: 0,
      must_appear: 0,
      Lists: null,
      contents:'',
      id:'',
    };
  },

  created() {
    ////console.log(this.$route.query.id);
    this.id=this.$route.query.id;
     if(this.id!=undefined){
       this.$nextTick(() => {
           Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/article/detail",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: { cid: this.id },
    }).then((res) => {
      ////console.log(res.data.data);
      this.Lists = res.data.data;
      this.dialogImageUrl = res.data.data.img;
      this.title1 = res.data.data.title;
      this.value1 = JSON.parse(res.data.data.patent_info);
      this.value2 = JSON.parse(res.data.data.report_info);
      this.contents=this.editor.txt.html(res.data.data.content);
    });
      });
     }
        Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/article/userReportSearch",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: { cid: this.id },
    }).then((res) => {
      ////console.log(res);
      this.optionsOne = res.data.data;
      if (this.value1 != "") {
        for (let i in this.value1) {
          this.valueOne.push(this.value1[i].id);
        }
        }
    });

       Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/article/userPatentSearch",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: { cid: this.id },
    }).then((res) => {
       ////console.log(res);
      this.optionsTwo = res.data.data;
      if (this.value2 != "") {
        for (let i in this.value2) {
          this.valueTwo.push(this.value2[i].id);
        }
      }
    });

     Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/article/userInfo",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: { cid: this.id },
    }).then((res) => {
     ////console.log(res);
      //  0普通
      // 1专家
      // 2机构
      var isbusiness = res.data.data.business;
      if (isbusiness == 0) {
        this.$confirm("您认证的信息还未通过暂时无法发布", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          })
          .catch(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          });
      }
    });
  },
  methods: {
    handleRemove(file, fileList) {
      ////console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    success(res, file, filelist) {
     
      if (res.code == 200) {
              ////console.log(res.data)
        this.dialogImageUrl = res.data;
      }
 
     
    },
    success1(res, file, filelist) {
      ////console.log(res)
      this.$refs["displaynone"].style = "display:none";
      this.$refs["displaynonei"].style = "display:block";
      if (res.code == 200) {
          this.dialogImageUrl =res.data;
      }
   
    },
    exMax(file, filelist) {
      this.$message.error("您超过了最大上传数");
    },
    ooos(id, name) {
      ////console.log(id);
      ////console.log(name);
    },
    selectChange1(id) {
      let obj = {};
      let Arr = [];
      for (let i in id) {
        obj = this.optionsOne.find((item) => {
          if (item.id === id[i]) {
            ////console.log(id[i]);
            ////console.log(item.chinese_title);
            Arr.push({ id: id[i], name: item.chinese_title });
            ////console.log(Arr);
            this.value1 = Arr;
          }
        });
      }
    },
    selectChange2(id) {
      let obj = {};
      let Arr1 = [];
      for (let i in id) {
        obj = this.optionsTwo.find((item) => {
          if (item.id === id[i]) {
            ////console.log(id[i]);
            ////console.log(item.patent_name);
            Arr1.push({ id: id[i], name: item.patent_name });
            ////console.log(Arr1);
            this.value2 = Arr1;
          }
        });
      }
    },
    onSubmit(status) {
      ////console.log(this.title1.length);
      ////console.log(this.value);
      if (!this.title1) {
        return this.$message.warning("标题内容不能为空");
      }
      if (this.title1.length < 8 || this.title1.length > 30) {
        return this.$message.warning("题为8-30字");
      }
      if(this.id!=undefined){
      if(this.value ==''){
         this.value=this.editor.txt.editor.$textElem[0].innerHTML
      }
            //  修改发布接口
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/api/article/save",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id:this.id,
          status:status,
          title: this.title1,
          content: this.value,
          img:this.dialogImageUrl,
          patent_info:JSON.stringify(this.value1),
          report_info:JSON.stringify(this.value2),
        },
      }).then((res) => {
        ////console.log(res);
        if (res.data.code != 200) {
          this.$message.warning(res.data.msg);
          return false;
        }
        if (res.data.code == 200) {
          this.$message.success("修改成功!");
          setTimeout(() => {
             this.$router.push("/PersonalCenter/Releases");
          }, 1000);
        }
      });
      }else{ 
        if(this.value==''){
        return this.$message.warning("内容不能为空!");
        }
           // 发布接口
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/api/article/save",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          status:status,
          title: this.title1,
          content: this.value,
          img: this.dialogImageUrl,
          patent_info:JSON.stringify(this.value1),
          report_info:JSON.stringify(this.value2),
        },
      }).then((res) => {
        ////console.log(res);
        if (res.data.code != 200) {
          this.$message.warning(res.data.msg);
          return false;
        }
        if (res.data.code == 200) {
          this.$message.success("您已成功发布文章!");
          setTimeout(() => {
             this.$router.push("/PersonalCenter/Releases");
          }, 1000);
         
        }
      });
      } 
    },
    seteditor() {
      var token = localStorage.getItem("token");
      //   var userInfo = JSON.parse(info);
      if (token == null) {
        token = {};
      }
      //   var token = userInfo.token;
      // http://192.168.2.125:8080/admin/storage/create
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      ////console.log(this.editor);
      //  ////console.log(this.editor.customConfig.uploadImgShowBase64)
      this.editor.customConfig.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.customConfig.uploadImgServer =
        this.editor.customConfig.debug = true;
      this.editor.customConfig.uploadImgServer =
        "https://researchadmin.qudong.com/api/upload/upload_img"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = { token }; // 自定义 header
      this.editor.customConfig.uploadFileName = "image"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 3; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间

      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        'fontName', // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        'table', // 表格
        "fullscreen", // 全屏
      ];
      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          ////console.log(result.data);
          // 图片上传成功，插入图片的回调
          // result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
          // ////console.log(result.data[0].url)
          // insertImg()为插入图片的函数
          // 循环插入图片
          // for (let i = 0; i < 1; i++) {
          // ////console.log(result)
          let url = result.data;
          insertImg(url);
        },
      };
      this.editor.customConfig.onchange = (html) => {
        ////console.log(html);
        this.value = html; // 将富文本的内容传给value
      };
      // 创建富文本编辑器
      this.editor.create();

      // var id = this.$route.query.contentid;
      // this.form.id = id;
      // ////console.log(id);
    },
  },

  mounted() {
    this.seteditor();  
  },
  // components: { UpLoadFile },
};
</script>

<style scoped>
.artic {
  width: 940px;
  background: #fff;
  padding-left: 30px;
}
.form .titleInp {
  position: relative;
}

.shortDiv {
  width: 60%;
  margin: 0 auto;
}

form .titleInp span,
form .titleInpS span {
  font-size: 1.5em;
  color: #c0c4cc;
  position: absolute;
  right: 0;
  bottom: 30px;
}

form .titleInpS span {
  font-size: 1.1em;
}

form .titleInp /deep/ .el-input__inner,
form .titleInpS /deep/ .el-input__inner {
  height: 100px !important;
  width: 100%;
  font-size: 2em;
  border-top: 1px solid transparent;
  border-right: 1px solid transparent;
  border-left: 1px solid transparent;
  font-weight: bold;
  outline: none;
  border-radius: 0;
}

form .titleInpS /deep/ .el-input__inner {
  font-size: 1.2em;
}

form .titleInp input:focus {
  border-bottom: 2px solid #a5c7fe;
}

form .contentInp textarea {
  height: 500px;
}

/*单图上传*/

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.borderLine {
  /* padding: 30px; */
}

.w-e-text {
  border: 1px solid #eee;
}

.x_srk {
  margin-bottom: 20px;
}

.el-date-picker {
  z-index: 111111 !important;
}

.Ktop_box {
  z-index: 50000000;
}
>>> .el-select {
  width: 300px;
}
.el-select-dropdown__item /deep/ {
  width: 300px !important;
}
/deep/.w-e-text-container .w-e-panel-container {
  top: 50px !important;
}
/deep/ .el-upload{
  position:relative;
}
/deep/ .el-icon-plus{
 position: absolute; left: 50%; top: 50%;   
    transform: translate(-50%, -50%);
    display:none;
}
</style>
